<template lang="pug">
Modal(
  :loading='loading'
  :remove-close-button='true'
  @process='disconnectIntegration'
  close-button-class='btn-close-integration'
  close-button-label='Fechar'
  process-button-class='btn-disconnect-integration'
  process-button-label='Desconectar'
  ref='modal'
  size='sm'
  title='Atenção'
)
  p.confirmation-text
    | Tem certeza de que deseja desconectar com a&ensp;
    strong {{ integration.name }}?
  p.hint-text
    | Você pode configurar novamente quando quiser.
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import alert from '@/modules/account/common/alert';
import IntegrationsService from '@/services/IntegrationsService';

export default {
  name: 'IntegrationDisconnectModal',
  components: { Modal },
  props: {
    integration: { type: Object, required: true },
    closeButtonClass: String,
    processButtonClass: String,
    showCloseIcon: { type: Boolean, default: true },
  },
  data() {
    return { loading: false };
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    async disconnectIntegration() {
      if (this.loading) return;
      this.loading = true;
      try {
        const organizationId = this.$store.state.organizations.selected.id;
        const res = await IntegrationsService.remove(
          this.integration.id,
          organizationId
        );
        if (res.status === 204) {
          alert.fireAlert(
            `Integração ${this.integration.name} desconectada com sucesso`,
            {
              classes: 'alert-success',
              styles:
                'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
              icon: 'circle-check',
            }
          );
          this.$emit('disconnected', this.integration);
          this.close();
        } else {
          throw new Error(`Status inesperado: ${res.status}`);
        }
      } catch (err) {
        alert.fireAlert(
          `Não foi possível desconectar a integração. ${
            err.response?.data?.message || err.message
          }`,
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
            icon: 'triangle-exclamation',
          }
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .modal-header {
  justify-content: center;
  border-bottom: none;
  padding-bottom: 0;
}

::v-deep.modal-title {
  font-weight: 600;
}

::v-deep .modal-body {
  padding: 24px !important;
  font-size: 14px !important;
}

::v-deep .modal-dialog.modal-sm {
  max-width: 400px;
}

.confirmation-text {
  font-family: var(--font-family-title);
  font-size: var(--font-size-sm);
  line-height: 21px;
}

::v-deep .modal-footer {
  padding: 0px 24px 24px 24px;
}

::v-deep .modal-footer .btn.btn-secondary {
  background-color: #ffffff;
  border: 1px solid #19665b;
  color: #19665b;
  padding: 8px;
  font-weight: 600;
  font-size: 14px;
}

::v-deep .modal-footer .btn-disconnect-integration {
  background-color: #dc342b;
  color: #ffffff;
  padding: 8px;
  font-weight: 600;
  font-size: 14px;
}
</style>
